import {
  GET_EMERGENCY_CONTACTS,
  GET_EMERGENCY_CONTACTS_SUCCESS,
  SET_CONTACTS_LOADING,
  CLEAR_EMERGENCY_CONTACTS_REDUCER,
  CREATE_PUPIL_CONTACTS,
  LINK_PUPIL_CONTACT,
  UPDATE_PUPIL_CONTACT,
  DELETE_PUPIL_CONTACT,
} from '../constants/ActionTypes';

export const setContactsLoading = isLoading => ({
  type: SET_CONTACTS_LOADING,
  payload: { isLoading },
});

export const getEmergencyContacts = () => ({
  type: GET_EMERGENCY_CONTACTS,
});

export const getEmergencyContactsSuccess = contacts => ({
  type: GET_EMERGENCY_CONTACTS_SUCCESS,
  payload: { contacts },
});

export const clearEmergencyContactsReducer = () => ({
  type: CLEAR_EMERGENCY_CONTACTS_REDUCER,
});

export const createPupilContact = ({ pupilId, contact, meta, setLoading }) => ({
  type: CREATE_PUPIL_CONTACTS,
  payload: {
    pupilId,
    contact,
    meta,
    setLoading,
  },
});

export const linkPupilContact = (pupilId, contact) => ({
  type: LINK_PUPIL_CONTACT,
  payload: {
    pupilId,
    contact,
  },
});

export const updatePupilContact = ({ pupilId, contact, meta, setLoading }) => ({
  type: UPDATE_PUPIL_CONTACT,
  payload: {
    pupilId,
    contact,
    meta,
    setLoading,
  },
});

export const deletePupilContact = ({ pupilId, contact }) => ({
  type: DELETE_PUPIL_CONTACT,
  payload: {
    pupilId,
    contact,
  },
});
